module.exports = __webpack_public_path__ + "d2cb5e06910496a29e37a6ccd1b25ef5.png";